import { render, staticRenderFns } from "./TiendaDescargas.vue?vue&type=template&id=cfaf99bc&scoped=true"
import script from "./TiendaDescargas.vue?vue&type=script&lang=js"
export * from "./TiendaDescargas.vue?vue&type=script&lang=js"
import style0 from "./TiendaDescargas.vue?vue&type=style&index=0&id=cfaf99bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfaf99bc",
  null
  
)

export default component.exports